<div class="location-edit">
  <h2>{{ isNew ? 'Add Location' : 'Edit Location' }}</h2>

  <dx-form [formData]="formData" [colCount]="2" labelLocation="top">
    <dxi-item dataField="name" editorType="dxTextBox" [label]="{ text: 'Name' }">
      <dxi-validation-rule type="required" message="Name is required"></dxi-validation-rule>
    </dxi-item>
    <dxi-item dataField="location_type" editorType="dxTextBox" [label]="{ text: 'Type' }">
      <dxi-validation-rule type="required" message="Type is required"></dxi-validation-rule>
    </dxi-item>
    <dxi-item dataField="location_token" editorType="dxTextBox"
      [label]="{ text: 'Token' }"
      [editorOptions]="{ readOnly: !isNew }">
      <dxi-validation-rule type="required" message="Token is required"></dxi-validation-rule>
    </dxi-item>
    <dxi-item dataField="address_line_1" editorType="dxTextBox" [label]="{ text: 'Address line 1' }"></dxi-item>
    <dxi-item dataField="address_line_2" editorType="dxTextBox" [label]="{ text: 'Address line 2' }"></dxi-item>
    <dxi-item dataField="suburb" editorType="dxTextBox" [label]="{ text: 'Suburb' }"></dxi-item>
    <dxi-item dataField="state" editorType="dxTextBox" [label]="{ text: 'State' }"></dxi-item>
    <dxi-item dataField="country" editorType="dxTextBox" [label]="{ text: 'Country' }"></dxi-item>
  </dx-form>

  <div class="actions">
    <dx-button text="Save" type="default" (onClick)="save()"></dx-button>
    <dx-button text="Cancel" (onClick)="cancel()"></dx-button>
  </div>
</div>
